// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__yG9co","title":"Images45_title__qTfMK","images":"Images45_images__2mn33"};